import { computed, inject, Injectable, signal } from "@angular/core";
import { EventDialogFuncData } from '@interfaces';
import { AppService, FuncService } from "../../../../services";
@Injectable({ providedIn: 'root' })
export class EventDialogDataService {

	private func = inject(FuncService);
	private app = inject(AppService);
	public event = signal<EventDialogFuncData | undefined>(undefined);

	public canEdit = computed(() => {
		const permissions = this.app.data().permissions;
		return permissions.canFacilitateCohorts || permissions.canEditAccSchedules;
	});

	public async loadEventData(eventId: number) {
		const event = await this.func.event.getDialogData({ eventId });
		this.event.set(event);
	}

	public async updateEvent(eventId: number, values: { startUTC: number, endUTC: number, toolStartUTC: number, toolEndUTC: number, link?: string, publicNotes?: string, hostPersonId: number, venueId?: number, }) {
		await this.func.event.update({ eventId, values });
		await this.loadEventData(eventId);
	}

	public async deleteEvent(eventId: number) {
		return await this.func.event.delete({ eventId });
	}


}